enum AssetMapAndDetailsConstants {
  SET_ASSET = '@AssetMapAndDetailsContainer/SET_ASSET',
  UPDATE_MAINTENANCE_REMINDER = '@AssetMapAndDetailsContainer/UPDATE_MAINTENANCE_REMINDER',
  SET_OUTDATED = '@AssetMapAndDetailsContainer/SET_OUTDATED',
  UNSET_ASSET = '@AssetMapAndDetailsContainer/UNSET_ASSET',
  GET_ASSET_DETAILS = '@AssetMapAndDetailsContainer/GET_ASSET_DETAILS',
  GET_ASSET_DETAILS_REQUEST = '@AssetMapAndDetailsContainer/GET_ASSET_DETAILS_REQUEST',
  GET_ASSET_DETAILS_SUCCESS = '@AssetMapAndDetailsContainer/GET_ASSET_DETAILS_SUCCESS',
  GET_ASSET_DETAILS_FAILURE = '@AssetMapAndDetailsContainer/GET_ASSET_DETAILS_FAILURE',
}

export default AssetMapAndDetailsConstants;
